module.exports = __webpack_public_path__ + "img/anoukclement-mecanika.18f7a35.jpg";